// extracted by mini-css-extract-plugin
module.exports = {"cls1":"GoNextLink-NativeLink-module--cls1--3v6zl","cls2":"GoNextLink-NativeLink-module--cls2--1INWp GoNextLink-NativeLink-module--cls1--3v6zl"};